import { render, staticRenderFns } from "./loginCaptcha.vue?vue&type=template&id=9a4b0696&scoped=true"
import script from "./loginCaptcha.vue?vue&type=script&lang=js"
export * from "./loginCaptcha.vue?vue&type=script&lang=js"
import style0 from "./loginCaptcha.vue?vue&type=style&index=0&id=9a4b0696&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4b0696",
  null
  
)

export default component.exports